export default __webpack_public_path__ + "static/media/check-circle.ce199ab2.svg";